import { IFsFileType } from "@r3f-component-data-structure";
import { FsVideo, HlsPlaylistVariant } from "./video";

export class FsVideo360 extends FsVideo {
    type: IFsFileType.Video360 = IFsFileType.Video360

    getPlaylistUrl(variant: HlsPlaylistVariant = 'vr') {
        const url = new URL(this.baseUrl)
        url.pathname = `${url.pathname}/${variant}.m3u8`
        return url.toString()
    }
}
